"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canResendAgreement = void 0;
var date_fns_1 = require("date-fns");
var canResendAgreement = function (rechCust) { var _a; return !rechCust.agreementLastSentOn || ((_a = rechCust.agreementLastSentOn) === null || _a === void 0 ? void 0 : _a.toDate()) < (0, date_fns_1.sub)(new Date(), { days: 1 }); };
exports.canResendAgreement = canResendAgreement;
